import spacing from '@/constants/spacing';
import {createThemedStyles} from '@/theme';

export const styles = createThemedStyles(() => ({
  priceInput: {
    textAlign: 'right',
  },
  priceCurrency: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
  },
}));
